var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44.95 55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    id: "\\uB808\\uC774\\uC5B4_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    id: "\\uB808\\uC774\\uC5B4_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "<\\uADF8\\uB8F9>",
    id: "_\\uADF8\\uB8F9_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32,20.22C-2.33,28.29.63,40.53,5.77,48c2.57,3.71,5.17,7,8.72,7h.2a10.77,10.77,0,0,0,4-1.08,11.09,11.09,0,0,1,4.8-1.14,10.43,10.43,0,0,1,4.57,1.1,9.67,9.67,0,0,0,4.37,1c4-.07,6.47-3.67,8.64-6.84a30.33,30.33,0,0,0,3.79-7.76l0,0a.45.45,0,0,0-.24-.55h0a11.49,11.49,0,0,1-7-10.52,11.83,11.83,0,0,1,5.59-9.89l0,0a.45.45,0,0,0,.13-.63,13,13,0,0,0-10.23-5.56c-.29,0-.59,0-.89,0a17.84,17.84,0,0,0-6.42,1.6,10.32,10.32,0,0,1-3.08.92,10.06,10.06,0,0,1-3.18-.93A15.42,15.42,0,0,0,14,13.21h-.14A13.75,13.75,0,0,0,2.32,20.22Z",
    "data-name": "<\\uD328\\uC2A4>",
    id: "_\\uD328\\uC2A4_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.22,0a12.56,12.56,0,0,0-8.29,4.25c-1.73,2-3.42,5.35-3,8.72a.45.45,0,0,0,.41.39l.58,0a10.62,10.62,0,0,0,7.83-4,12.4,12.4,0,0,0,2.92-9A.45.45,0,0,0,33.22,0Z",
    "data-name": "<\\uD328\\uC2A4>",
    id: "_\\uD328\\uC2A4_2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.fa8ed06bf14c2bcfd7d093ef9911893c.svg";
export { ForwardRef as ReactComponent };